<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">Atheer - Iraq</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">12,096</td>
                            <td class="end font">54,806</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Pella - Jordan</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,020</td>
                            <td class="end font">5,314</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Other</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">2,414</td>
                            <td class="end font">1,655</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">20,530</td>
                            <td class="end font white font-weight-bold">61,775</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">أثير - العراق</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">12,096</td>
                            <td class="end font">54,806</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">بيلا - الأردن</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,020</td>
                            <td class="end font">5,314</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">أخرى</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">2,414</td>
                            <td class="end font">1,655</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">20,530</td>
                            <td class="end font white font-weight-bold">61,775</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>